import React from 'react';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';

interface PasswordRequirementsProps {
    password?: string;
}

const PasswordRequirements: React.FC<PasswordRequirementsProps> = ({ password = '' }) => {
    const requirements = [
        { check: password.length >= 8, label: 'At least 8 characters long' },
        { check: /[A-Z]/.test(password), label: 'Contains uppercase letter (A-Z)' },
        { check: /[a-z]/.test(password), label: 'Contains lowercase letter (a-z)' },
        { check: /\d/.test(password), label: 'Contains a number (0-9)' },
        { check: /[!@#$%^&*(),.?":{}|<>]/.test(password), label: 'Contains a special character (!@#$%^&*)' }
    ];

    return (
        <div style={{ padding: 8 }}>
            <h4 style={{ margin: '0 0 8px', fontSize: 13, fontWeight: 600, color: '#374151' }}>Password must contain:</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                {requirements.map((req, idx) => (
                    <div key={idx} style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12 }}>
                        {req.check ? (
                            <CheckCircleFilled style={{ color: '#10b981', fontSize: 14 }} />
                        ) : (
                            <CloseCircleFilled style={{ color: '#9ca3af', fontSize: 14 }} />
                        )}
                        <span style={{ color: req.check ? '#374151' : '#6b7280' }}>
                            {req.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default PasswordRequirements;
